<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">إدخال طلب تبرع هاتفي</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "donationcallrequestForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> الأسم</label>
                                <input class="form-control" id="validation01" type="text" formControlName="name"
                                [tooltip]="fc.name.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.name.valid && (fc.name.touched)"
                                [class.is-invalid]="fc.name.invalid && (fc.name.touched)"
                                
                                     required
                                     placeholder="الأسم"
                                    containerClass="" />
                            </div>
                            <!-- mobile  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> الهاتف</label>
                                <input class="form-control" id="validation01" type="text" formControlName="mobile"
                                [tooltip]="fc.mobile.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.mobile.valid && (fc.mobile.touched)"
                                [class.is-invalid]="fc.mobile.invalid && (fc.mobile.touched)"
                                onlyNumbers
                                     required
                                     placeholder="الهاتف"
                                    containerClass="" />
                            </div>
                             
                            <div class="col-6 mb-3">
                                <label for="validationCustom05"><span class="validation-required">*</span> المدينة </label>
                                <ng-select #Governorate  [selectOnTab]="true" formControlName="cityId"
                                    class="form-control p-0" placeholder="اختر المدينة"
                                    containerClass="" 
                                    id="validationCustom05">
                                    <ng-option *ngFor="let item of cities" [value]="item.id">{{item.title}}</ng-option>
                                </ng-select>
                            </div>
                   </div>
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

